import { Donation, CampaignStats, DonationTier } from "../types";

export const mockStats: CampaignStats = {
  totalRaised: 1250,
  target: 15000,
  donorCount: 8,
};

export const mockDonations: Donation[] = [
  {
    id: "1",
    amount: 100,
    name: "Sister Grace",
    message: "Let there be light!",
    timestamp: Date.now() - 3600000,
  },
  {
    id: "2",
    amount: 250,
    name: "Brother Thomas",
    message: "For the children of Limpopo",
    timestamp: Date.now() - 7200000,
  },
  {
    id: "3",
    amount: 50,
    name: "Anonymous Supporter",
    message: "God bless this mission",
    timestamp: Date.now() - 14400000,
  },
  {
    id: "4",
    amount: 1000,
    name: "Pastor Eze",
    message: "From our congregation to yours",
    timestamp: Date.now() - 28800000,
  },
  {
    id: "5",
    amount: 25,
    name: "Mary K.",
    message: "",
    timestamp: Date.now() - 43200000,
  },
  {
    id: "6",
    amount: 100,
    name: "David & Ruth",
    message: "Shine His light everywhere",
    timestamp: Date.now() - 86400000,
  },
];

export const donationTiers: DonationTier[] = [
  {
    amt: 25,
    label: "Friend of the Light",
    benefit: "Powers 5 LED bulbs for a year",
    featured: false,
  },
  {
    amt: 100,
    label: "Community Pillar",
    benefit: "Covers cost of 1 solar panel",
    featured: true,
  },
  {
    amt: 250,
    label: "Parish Guardian",
    benefit: "Powers a night-school classroom",
    featured: false,
  },
  {
    amt: 1000,
    label: "Sanctuary Builder",
    benefit: "Full installation for 1 rural parsonage",
    featured: false,
  },
];

export const roadmapSteps = [
  {
    step: "01",
    title: "Site Assessment",
    desc: "Engineers survey roof integrity and sun path.",
  },
  {
    step: "02",
    title: "Youth Training",
    desc: "Parish youth learn installation and maintenance.",
  },
  {
    step: "03",
    title: "Hardware Ship",
    desc: "Panels, batteries, and inverters arrive on site.",
  },
  {
    step: "04",
    title: "Switching On",
    desc: "The church lights up, enabling night services.",
  },
];
